import type { Action } from '../typings/reducers';

type Strategy = Record<string, unknown> & { _id?: string };
type StrategiesState = {
  all: Strategy[];
  benefits: unknown[];
  goals: unknown[];
  current?: Strategy;
  isModalOpen?: boolean;
};

export default function (
  state: StrategiesState = { all: [], benefits: [], goals: [] },
  action: Action
): StrategiesState {
  switch (action.type) {
    case 'SET_ALL_STRATEGIES':
      return { ...state, all: action.payload };
    case 'SET_CURRENT_STRATEGY':
      let current = action.payload;
      if (current.id) {
        current = state.all.find((strategy) => strategy._id === current.id);
      }

      return { ...state, current };
    case 'SET_STRATEGY_MODAL_VISIBILITY':
      return { ...state, isModalOpen: action.payload };
    case 'SET_ALL_BENEFITS':
      return { ...state, benefits: action.payload };
    case 'SET_ALL_GOALS':
      return { ...state, goals: action.payload };
    default:
      return state;
  }
}
